'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuStyleProcessor = require('@ali/vu-style-processor');

var _vuStyleProcessor2 = _interopRequireDefault(_vuStyleProcessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window:true document:true */


function memoize(fn) {
  var memo = void 0;
  return function memofiy() {
    if (memo == null) memo = fn();
    return memo;
  };
}

var isOldIE = memoize(function () {
  return (/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
  );
});
var singletonCssText = [];
var singletonCounter = 0;
var singletonStyleElement = null;

function getClassName(selector) {
  var m = /^\.(.*)$/.exec(selector);
  if (m) {
    return m[1];
  }
  return null;
}

function replaceSingletonCssText(index, replacement) {
  singletonCssText[index] = replacement;
  return singletonCssText.filter(Boolean).join('\n');
}

var Storage = function () {
  function Storage() {
    _classCallCheck(this, Storage);

    this.styleElement = _vuStyleProcessor2.default.createStyleElement('style-sheet');
  }

  Storage.prototype.write = function write(css) {
    var styleElement = this.styleElement;
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = css;
    } else {
      while (styleElement.firstChild) {
        styleElement.removeChild(styleElement.firstChild);
      }
      styleElement.appendChild(document.createTextNode(css));
    }
  };

  Storage.prototype.remove = function remove() {
    var styleElement = this.styleElement;
    styleElement.parentNode.removeChild(styleElement);
  };

  return Storage;
}();

var SingletonStorage = function () {
  function SingletonStorage() {
    _classCallCheck(this, SingletonStorage);

    this.index = singletonCounter++;
    if (!singletonStyleElement) {
      singletonStyleElement = _vuStyleProcessor2.default.createStyleElement('style-sheet');
    }
    this.styleElement = singletonStyleElement;
  }

  SingletonStorage.prototype.write = function write(css) {
    var index = this.index;
    var styleElement = this.styleElement;
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = replaceSingletonCssText(index, css);
    } else {
      var cssNode = document.createTextNode(css);
      var childNodes = styleElement.childNodes;
      if (childNodes[index]) styleElement.removeChild(childNodes[index]);
      if (childNodes.length) {
        styleElement.insertBefore(cssNode, childNodes[index]);
      } else {
        styleElement.appendChild(cssNode);
      }
    }
  };

  SingletonStorage.prototype.remove = function remove() {
    this.write('');
  };

  return SingletonStorage;
}();

var StyleSheet = function () {
  function StyleSheet() {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.maps = {};
    this.precache = {};
    this.ready = false;
    this.isSingleton = isOldIE();
    _vuStyleProcessor2.default.ready(function () {
      return _this.prepare();
    });
  }

  StyleSheet.prototype.setDesignMode = function setDesignMode(flag) {
    _vuStyleProcessor2.default.setDesignMode(flag);
  };

  StyleSheet.prototype.setNamespace = function setNamespace(namespace) {
    _vuStyleProcessor2.default.setNamespace(namespace);
  };

  StyleSheet.prototype.prepare = function prepare() {
    this.ready = true;
    for (var selector in this.precache) {
      if (this.precache.hasOwnProperty(selector)) {
        this.write(selector, this.precache[selector]);
      }
    }
    this.precache = null;
  };

  StyleSheet.prototype.cache = function cache(selector, css) {
    this.precache[selector] = css;
  };

  StyleSheet.prototype.write = function write(selector, css) {
    if (!css) {
      this.remove(selector);
      return;
    }

    var storage = this.getStorage(selector);
    storage.write(css);
  };

  StyleSheet.prototype.getStorage = function getStorage(selector) {
    if (!this.maps[selector]) {
      this.maps[selector] = this.isSingleton ? new SingletonStorage() : new Storage();
    }
    return this.maps[selector];
  };

  StyleSheet.prototype.remove = function remove(selector) {
    var storage = this.maps[selector];
    if (storage) {
      storage.remove();
      this.maps[selector] = null;
    }
  };

  StyleSheet.prototype.clear = function clear() {
    if (this.ready) {
      for (var selector in this.maps) {
        if (this.maps.hasOwnProperty(selector)) {
          this.remove(selector);
        }
      }
    } else {
      this.precache = {};
    }
  };

  // selector must be unique


  StyleSheet.prototype.invoke = function invoke(selector, styles, className) {
    /**
     * styles = {
     *   default: {},
     *   hover: {},
     *   focus: {},
     *   active: {},
     * }
     * css = 'selector{}, selector:hover {}'
     */
    if (className && !_vuStyleProcessor2.default.isDesignMode()) {
      return className;
    }
    if (!styles) {
      return null;
    }
    var css = _vuStyleProcessor2.default.createCss(selector, styles);
    if (this.ready) {
      this.write(selector, css);
    } else {
      this.cache(selector, css);
    }
    return getClassName(selector);
  };

  return StyleSheet;
}();

if (!window.__visionStyleSheet) {
  window.__visionStyleSheet = new StyleSheet();
}

exports.default = new StyleSheet();
module.exports = exports['default'];